export const SOURCE = {
    LENDER_REQ: 'lenderReq',
    BORROWER_REQ: 'borrowerReq',
};

export const COMPOSE_EMAIL_SOURCE = {
    LENDER_QUERY: 'LENDER_QUERY',
    DEALS_PAGE: 'DEALS_PAGE',
    DASHBOARD_HEADER: 'DASHBOARD_HEADER',
    DATA_PENDING: 'DATA_PENDING',
    LEADS: 'LEADS',
};

export const TAB_STATE = {
    ACTIVE: 'active',
    ARCHIVED: 'archived',
} as const;

export type TabState = (typeof TAB_STATE)[keyof typeof TAB_STATE];

export type LenderRequirementStatus = 'PENDING' | 'COMPLETE'; // Assuming COMPLETE is the other status besides PENDING

export interface UpdateLenderRequirementPayload {
    id: number;
    status: LenderRequirementStatus;
    dataType: string;
    updatedBy: string;
}

export enum AicaChaseStatus {
    ACTIVE = 'ACTIVE',
    ATTEMPTS_OVER = 'ATTEMPTS_OVER',
    TURNED_OFF = 'TURNED_OFF',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export interface UpdateAicaChaseStatusPayload {
    orgId: string;
    status: AicaChaseStatus;
    journey: string;
}

export interface UpdateLenderAicaChaseStatusPayload {
    dealId: string;
    status: AicaChaseStatus;
    lastUpdatedBy: string;
    journey: string;
}
